// Constant Data for Fast Sell Price Offer

export const USERABLE_TYPE = {
  ADMIN  : 'admin',
  SELLER : 'seller'
}
